// MUI multiplies numeric sx values (borderRadius: 2) by shape.borderRadius,
// so this base is 4: 1 -> 4px, 1.5 -> 6px, 2 -> 8px.
export const shape = {
  borderRadius: 4,
};

// Small, tight scale. md = buttons/inputs/nav rows, lg = cards/dialogs,
// xl = the floating sidebar panel only, pill = avatars/badges/chips.
export const radius = {
  sm: 4,
  md: 6,
  lg: 8,
  xl: 12,
  pill: 999,
};
